export default __webpack_public_path__ + "static/sub-45393a7e9510d2131477cd4d551a189b.png";